import React from "react";
import {withTranslation} from "react-i18next";
import Utils from "../../../../../../../utils/Utils";
import CheckBoxTable from "./CheckBoxTable";


class DiagnosiEseguitaInfluenzaMIB extends React.Component {

    state = {
        diagnosiInfluenza: {
            liquorInfluenza: this.props.statePadre && this.props.statePadre.liquorInfluenza ? this.props.statePadre.liquorInfluenza : false,
            sangueInfluenza: this.props.statePadre && this.props.statePadre.sangueInfluenza ? this.props.statePadre.sangueInfluenza : false,
            liquidoPleuricoInfluenza: this.props.statePadre && this.props.statePadre.liquidoPleuricoInfluenza ? this.props.statePadre.liquidoPleuricoInfluenza : false,
            liquidoPeritonealeInfluenza: this.props.statePadre && this.props.statePadre.liquidoPeritonealeInfluenza ? this.props.statePadre.liquidoPeritonealeInfluenza : false,
            liquidoPericardioInfluenza: this.props.statePadre && this.props.statePadre.liquidoPericardioInfluenza ? this.props.statePadre.liquidoPericardioInfluenza : false,
            liquidoSinovialeInfluenza: this.props.statePadre && this.props.statePadre.liquidoSinovialeInfluenza ? this.props.statePadre.liquidoSinovialeInfluenza : false,
            placentaInfluenza: this.props.statePadre && this.props.statePadre.placentaInfluenza ? this.props.statePadre.placentaInfluenza : false,
            materialeInfluenza: this.props.statePadre && this.props.statePadre.materialeInfluenza ? this.props.statePadre.materialeInfluenza : false,

            colturaInfluenzaLiquor1: this.props.statePadre && this.props.statePadre.colturaInfluenzaLiquor1 ? this.props.statePadre.colturaInfluenzaLiquor1 : false,
            colturaInfluenzaSangue2: this.props.statePadre && this.props.statePadre.colturaInfluenzaSangue2 ? this.props.statePadre.colturaInfluenzaSangue2 : false,
            colturaInfluenzaPleurico3: this.props.statePadre && this.props.statePadre.colturaInfluenzaPleurico3 ? this.props.statePadre.colturaInfluenzaPleurico3 : false,
            colturaInfluenzaPeritoneale4: this.props.statePadre && this.props.statePadre.colturaInfluenzaPeritoneale4 ? this.props.statePadre.colturaInfluenzaPeritoneale4 : false,
            colturaInfluenzaPericardio5: this.props.statePadre && this.props.statePadre.colturaInfluenzaPericardio5 ? this.props.statePadre.colturaInfluenzaPericardio5 : false,
            colturaInfluenzaSinoviale6: this.props.statePadre && this.props.statePadre.colturaInfluenzaSinoviale6 ? this.props.statePadre.colturaInfluenzaSinoviale6 : false,
            colturaInfluenzaPlacenta7: this.props.statePadre && this.props.statePadre.colturaInfluenzaPlacenta7 ? this.props.statePadre.colturaInfluenzaPlacenta7 : false,
            colturaInfluenzaMateriale8: this.props.statePadre && this.props.statePadre.colturaInfluenzaMateriale8 ? this.props.statePadre.colturaInfluenzaMateriale8 : false,

            pcrInfluenzaLiquor1: this.props.statePadre && this.props.statePadre.pcrInfluenzaLiquor1 ? this.props.statePadre.pcrInfluenzaLiquor1 : false,
            pcrInfluenzaSangue2: this.props.statePadre && this.props.statePadre.pcrInfluenzaSangue2 ? this.props.statePadre.pcrInfluenzaSangue2 : false,
            pcrInfluenzaPleurico3: this.props.statePadre && this.props.statePadre.pcrInfluenzaPleurico3 ? this.props.statePadre.pcrInfluenzaPleurico3 : false,
            pcrInfluenzaPeritoneale4: this.props.statePadre && this.props.statePadre.pcrInfluenzaPeritoneale4 ? this.props.statePadre.pcrInfluenzaPeritoneale4 : false,
            pcrInfluenzaPericardio5: this.props.statePadre && this.props.statePadre.pcrInfluenzaPericardio5 ? this.props.statePadre.pcrInfluenzaPericardio5 : false,
            pcrInfluenzaSinoviale6: this.props.statePadre && this.props.statePadre.pcrInfluenzaSinoviale6 ? this.props.statePadre.pcrInfluenzaSinoviale6 : false,
            pcrInfluenzaPlacenta7: this.props.statePadre && this.props.statePadre.pcrInfluenzaPlacenta7 ? this.props.statePadre.pcrInfluenzaPlacenta7 : false,
            pcrInfluenzaMateriale8: this.props.statePadre && this.props.statePadre.pcrInfluenzaMateriale8 ? this.props.statePadre.pcrInfluenzaMateriale8 : false,
            corretto: []
        },
        malattiaBatterica: "",
        id: "",
        rowList: [],
        row: 0
    }

    constructor(props) {
        super(props)
        this.createOggettoBE = this.createOggettoBE.bind(this);
        this.controlloDati = this.controlloDati.bind(this);
        this.setStateGenerico = this.setStateGenerico.bind(this)
    }

    componentDidMount() {

        let diagnosiInfluenza = this.state.diagnosiInfluenza

        let statePadre = JSON.parse(JSON.stringify(this.props.statePadre))
        delete statePadre["corretto"];

        if(Utils.isEmpty(statePadre)) {
            if (this.props.malattiaBatterica !== "malattiaBatterica3") {
                diagnosiInfluenza.corretto = true
            } else if (this.props.malattiaBatterica === "malattiaBatterica3") {
                if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.diagnosiInfluenza) {
                    let diagnosiInfluenzaProps = this.props.segnalazioneCopia.schedaSpeciale.diagnosiInfluenza
                    for (let key in diagnosiInfluenza) {
                        if (diagnosiInfluenza.hasOwnProperty(key) === diagnosiInfluenzaProps.hasOwnProperty(key)) {
                            diagnosiInfluenza[key] = diagnosiInfluenzaProps[key]
                        } else {
                            diagnosiInfluenza[key] = false
                        }
                    }
                }
                // this.controlloDati()
            }
            this.setState({diagnosiInfluenza: diagnosiInfluenza, malattiaBatterica: this.props.malattiaBatterica})
        }
        let oggetto = this.createOggettoBE()
        this.props.setDiagnosiInfluenza(this.state.diagnosiInfluenza, oggetto)

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.malattiaBatterica != this.props.malattiaBatterica) {
            if (this.props.malattiaBatterica !== "malattiaBatterica3") {
                let diagnosiInfluenza = this.state.diagnosiInfluenza
                for (let key in diagnosiInfluenza) {
                    diagnosiInfluenza[key] = false
                }
                // diagnosiInfluenza.corretto = true
                this.setState({diagnosiInfluenza: diagnosiInfluenza, malattiaBatterica: this.props.malattiaBatterica})

            } else {
                this.setState({malattiaBatterica: this.props.malattiaBatterica})
            }
            // this.controlloDati()
            let oggetto = this.createOggettoBE()
            this.props.setDiagnosiInfluenza(this.state.diagnosiInfluenza, oggetto)
        }

    }

    createOggettoBE() {
        let diagnosiInfluenza = JSON.parse(JSON.stringify(this.state.diagnosiInfluenza))
        let diagnosiInfluenzaBe = Utils.removeEmptyValueFromObject(diagnosiInfluenza)
        return Utils.removeFieldFromObject(diagnosiInfluenzaBe, "corretto")
    }

    controlloDati() {
        let diagnosiInfluenza = this.state.diagnosiInfluenza
        diagnosiInfluenza.corretto = []

        if (!(
            diagnosiInfluenza.liquorInfluenza && (diagnosiInfluenza.colturaInfluenzaLiquor1 || diagnosiInfluenza.pcrInfluenzaLiquor1) ||
            diagnosiInfluenza.sangueInfluenza && (diagnosiInfluenza.colturaInfluenzaSangue2 || diagnosiInfluenza.pcrInfluenzaSangue2) ||
            diagnosiInfluenza.liquidoPleuricoInfluenza && (diagnosiInfluenza.colturaInfluenzaPleurico3 || diagnosiInfluenza.pcrInfluenzaPleurico3) ||
            diagnosiInfluenza.liquidoPeritonealeInfluenza && (diagnosiInfluenza.colturaInfluenzaPeritoneale4 || diagnosiInfluenza.pcrInfluenzaPeritoneale4) ||
            diagnosiInfluenza.liquidoPericardioInfluenza && (diagnosiInfluenza.colturaInfluenzaPericardio5 || diagnosiInfluenza.pcrInfluenzaPericardio5) ||
            diagnosiInfluenza.liquidoSinovialeInfluenza && (diagnosiInfluenza.colturaInfluenzaSinoviale6 || diagnosiInfluenza.pcrInfluenzaSinoviale6) ||
            diagnosiInfluenza.placentaInfluenza && (diagnosiInfluenza.colturaInfluenzaPlacenta7 || diagnosiInfluenza.pcrInfluenzaPlacenta7) ||
            diagnosiInfluenza.materialeInfluenza && (diagnosiInfluenza.colturaInfluenzaMateriale8 || diagnosiInfluenza.pcrInfluenzaMateriale8))) {
            diagnosiInfluenza.corretto[0] = "Campo \"Emofilo (H. Influenzae)\" mancante o errato";
        }

        this.setState({diagnosiInfluenza: diagnosiInfluenza})

    }

    setStateGenerico(object) {
        this.setState(object)
        // this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setDiagnosiInfluenza(this.state.diagnosiInfluenza, oggetto)
    }

    render() {
        let disabled = this.props.malattiaBatterica && this.props.malattiaBatterica != "malattiaBatterica3" ? true : false
        let rows_Influenza = [
            {
                check1Liquor1_Influenza1: {
                    id: "liquorInfluenza",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.1",
                    radio: false,
                    field: "liquorInfluenza",
                    numeroCol: 1,
                    row: 1
                },
                check1Liquor2_Influenza2: {
                    id: "colturaInfluenzaLiquor1",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "colturaInfluenzaLiquor",
                    numeroCol: 2,
                    row: 1
                },
                check1Liquor3_Influenza3: {
                    id: "pcrInfluenzaLiquor1",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcrInfluenzaLiquor",
                    numeroCol: 4,
                    row: 1
                }
            },
            {
                check1Sangue1_Influenza1: {
                    id: "sangueInfluenza",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.2",
                    radio: false,
                    field: "sangueInfluenza",
                    numeroCol: 1,
                    row: 2
                },
                check1Sangue2_Influenza2: {
                    id: "colturaInfluenzaSangue2",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "colturaInfluenzaSangue",
                    numeroCol: 2,
                    row: 2
                },
                check1Sangue3_Influenza3: {
                    id: "pcrInfluenzaSangue2",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcrInfluenzaSangue",
                    numeroCol: 4,
                    row: 2
                }
            },
            {
                check1Pleurico1_Influenza1: {
                    id: "liquidoPleuricoInfluenza",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.3",
                    radio: false,
                    field: "liquidoPleuricoInfluenza",
                    numeroCol: 1,
                    row: 3
                },
                check1Pleurico2_Influenza2: {
                    id: "colturaInfluenzaPleurico3",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "colturaInfluenzaPleurico",
                    numeroCol: 2,
                    row: 3
                },
                check1Pleurico3_Influenza3: {
                    id: "pcrInfluenzaPleurico3",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcrInfluenzaPleurico",
                    numeroCol: 4,
                    row: 3
                }
            },
            {
                check1Peritoneale1_Influenza1: {
                    id: "liquidoPeritonealeInfluenza",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.4",
                    radio: false,
                    field: "liquidoPeritonealeInfluenza",
                    numeroCol: 1,
                    row: 4
                },
                check1Peritoneale2_Influenza2: {
                    id: "colturaInfluenzaPeritoneale4",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "colturaInfluenzaPeritoneale",
                    numeroCol: 2,
                    row: 4
                },
                check1Peritoneale3_Influenza3: {
                    id: "pcrInfluenzaPeritoneale4",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcrInfluenzaPeritoneale",
                    numeroCol: 4,
                    row: 4
                }
            },
            {
                check1Pericardio1_Influenza1: {
                    id: "liquidoPericardioInfluenza",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.5",
                    radio: false,
                    field: "liquidoPericardioInfluenza",
                    numeroCol: 1,
                    row: 5
                },
                check1Pericardio2_Influenza2: {
                    id: "colturaInfluenzaPericardio5",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "colturaInfluenzaPericardio",
                    numeroCol: 2,
                    row: 5
                },
                check1Pericardio3_Influenza3: {
                    id: "pcrInfluenzaPericardio5",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcrInfluenzaPericardio",
                    numeroCol: 4,
                    row: 5
                }
            },
            {
                check1Sinoviale1_Influenza1: {
                    id: "liquidoSinovialeInfluenza",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.8",
                    radio: false,
                    field: "liquidoSinovialeInfluenza",
                    numeroCol: 1,
                    row: 6
                },
                check1Sinoviale2_Influenza2: {
                    id: "colturaInfluenzaSinoviale6",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "colturaInfluenzaSinoviale",
                    numeroCol: 2,
                    row: 6
                },
                check1Sinoviale3_Influenza3: {
                    id: "pcrInfluenzaSinoviale6",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcrInfluenzaSinoviale",
                    numeroCol: 4,
                    row: 6
                }
            },
            {
                check1Placenta1_Influenza1: {
                    id: "placentaInfluenza",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.6",
                    radio: false,
                    field: "placentaInfluenza",
                    numeroCol: 1,
                    row: 7
                },
                check1Placenta2_Influenza2: {
                    id: "colturaInfluenzaPlacenta7",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "colturaInfluenzaPlacenta",
                    numeroCol: 2,
                    row: 7
                },
                check1Placenta3_Influenza3: {
                    id: "pcrInfluenzaPlacenta7",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcrInfluenzaPlacenta",
                    numeroCol: 4,
                    row: 7
                }
            },
            {
                check1Materiale1_Influenza1: {
                    id: "materialeInfluenza",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.9",
                    radio: false,
                    field: "materialeInfluenza",
                    numeroCol: 1,
                    row: 8
                },
                check1Materiale2_Influenza2: {
                    id: "colturaInfluenzaMateriale8",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.10",
                    radio: true,
                    field: "colturaInfluenzaMateriale",
                    numeroCol: 2,
                    row: 8
                },
                check1Materiale3_Influenza3: {
                    id: "pcrInfluenzaMateriale8",
                    text: "SchedaFlussoSpeciale.MIB.DiagnosiEseguita.12",
                    radio: true,
                    field: "pcrInfluenzaMateriale",
                    numeroCol: 4,
                    row: 8
                }
            }]

        return (
            <div>
                <fieldset disabled={this.props.malattiaBatterica != "malattiaBatterica3"}>
                    <CheckBoxTable tipoMalattiaBattareica={"malattiaBatterica3"}
                                   intestazione={"SchedaFlussoSpeciale.MIB.DiagnosiEseguita.titolo3"}
                                   stato={this.state.diagnosiInfluenza}
                                   disabled={disabled} rows={rows_Influenza} rowList={this.state.rowList}
                                   setStatePadre={this.setStateGenerico} id={this.state.id} row={this.state.row}/>
                </fieldset>
            </div>
        )
    }

}

export default withTranslation('common')(DiagnosiEseguitaInfluenzaMIB)


